import Selectors from '../../../selectors/pages/CrashPage'

export class CrashPage {
  static readonly selectors = Selectors
  readonly selectors = Selectors
}
